import { render, staticRenderFns } from "./purchaseOrderDataTable.vue?vue&type=template&id=c8d5364c&"
import script from "./purchaseOrderDataTable.vue?vue&type=script&lang=js&"
export * from "./purchaseOrderDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports